
// src/web/components/templates-panel.jsx

import React from 'react'
import {
  Card,
  CardText,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import {
  IconMenu,
  MenuItem,
} from 'react-toolbox/lib/menu'
import Loading from './loading.jsx'
import theme from './themes/flat-card.css'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import ConfirmDialog from './confirm-dialog.jsx'
import successButtonTheme from './themes/success-button.css'
import templateListTheme from './themes/template-panel.css'
import _ from 'lodash'

class TemplatesPanel extends React.Component {
  state = { showMenu: false }

  cloneTemplate = (template) => {
    if(template){
      var cloneTemplate = template
      cloneTemplate.template_id = undefined
      return cloneTemplate
    } else {
      return template
    } 
  }

  render() {
    const {
      t,
      templates,
      newTemplate,
      editTemplate,
      deleteTemplate,
      isFetching,
    } = this.props

    return (
      <Card theme={theme}>
        <CardText>
          <Button raised theme={successButtonTheme}
            icon='add'
            label={t('label:新規作成')}
            onClick={() => newTemplate(this.props)} />
        </CardText>

        <CardText>
          {isFetching &&
            <Loading />
          }
          {!isFetching &&
            <List selectable>
              {!isFetching && (!templates || templates.length == 0) &&
                <ListItem caption={t('label:テンプレートは登録されていません')} selectable={false} />
              }
              {templates && _.map(templates, (template) => {
                return(
                  <ListItem key={template.template_id}
                  theme={templateListTheme}
                  selectable={true}
                  ripple={true}
                  caption={template.name}
                  onClick={()=> editTemplate(this.props, template.template_id)}
                  rightActions={[
                    <IconMenu key="menu" icon="more_vert" onClick={()=> this.setState({ showMenu: true })}>
                      <MenuItem
                          icon="content_copy"
                          onClick={()=> newTemplate(this.props, this.cloneTemplate(template))}
                          caption={t('label:コピーして新規作成')} />
                      <MenuItem
                      icon="delete_forever"
                      onClick={()=> this.setState({ [`deleteConfirm${template.template_id}`]: true })}
                      caption={t('label:削除')} />
                    </IconMenu>,
                    <ConfirmDialog key="dialog"
                      title={t('label:テンプレートを削除してもいいですか', { name: template.name })}
                      description={t('label:この操作は取り消せません')}
                      open={this.state[`deleteConfirm${template.template_id}`]}
                      yesLabel={t('label:削除')}
                      noLabel={t('label:取り消し')}
                      onYes={()=> { this.setState({ [`deleteConfirm${template.template_id}`]: false }); deleteTemplate(template) }}
                      onNo={()=> this.setState({ [`deleteConfirm${template.template_id}`]: false })} />,     
                  ]}/>)
              })}
            </List>
          }
        </CardText>
      </Card>
    )
  }
}

export default TemplatesPanel



// WEBPACK FOOTER //
// ./src/web/components/templates-panel.jsx